<div class="pdfViewer">

  <div [ngClass]="{'pdfViewer_hide': !isLoaded}">
    <pdf-viewer class="pdfViewer-viewer" [src]="pdfSrc" [render-text]="false" [zoom]="zoom" [show-all]="false"
      [autoresize]="true" [original-size]="false" [fit-to-page]="true" [page]="page"
      (after-load-complete)="afterLoadComplete($event)">
    </pdf-viewer>

    <div class="pdfViewer-toolbar">
      <button [style.visibility]="currentMultimodalStepIndex > 0 ? 'visible' : 'hidden'" class="btn btn_sm pdfViewer-previous" svgIcon
        [icon]="'arrow'" (click)="goBack()">&nbsp;{{ 'GENERAL.BACK' | translate}}</button>

      <div class="pdfViewer-pagination d-flex">
        <button class="btn btn_sm pdfViewer-previous" (click)="prevPage()" [disabled]="page === 1" svgIcon
          [icon]="'arrow'"></button>
        <div class="pdfViewer-currentPage">
          {{ 'OFFER.PREVIEW.PAGE' | translate }} {{page}} / {{ totalPages }}
        </div>
        <button class="btn btn_sm pdfViewer-next" (click)="nextPage()" [disabled]="page === totalPages" svgIcon
          [icon]="'arrow'"></button>
      </div>

      <div class="pdfViewer-actions d-flex">
        <button class="btn btn_sm pdfViewer-zoom" (click)="decreaseZoom()" [disabled]="zoom === minZoom" svgIcon
          [icon]="'zoom-out'"></button>
        <button class="btn btn_sm pdfViewer-zoom" (click)="increaseZoom()" [disabled]="zoom === maxZoom" svgIcon
          [icon]="'zoom-in'"></button>
        <button class="btn btn_sm btn_link btn_icon" (click)="print()" svgIcon
          [icon]="'printer'">{{ 'OFFER.PREVIEW.PRINT' | translate }}</button>
        <button class="btn btn_sm btn_link btn_icon pr-0 ml-0" (click)="download()" svgIcon
          [icon]="'download'">{{ 'OFFER.PREVIEW.DOWNLOAD' | translate }}</button>
      </div>
    </div>
  </div>

</div>
